import { Component, OnInit } from '@angular/core';
import { AuthRepository } from '../../../../state/auth.repository';
import { DocumentTypesRepository } from '../../../../state/documenttype.repository';
import { DocumentTypesService } from '../../../../state/documenttype.service';
import { TenantFeatures } from 'app/state/feature.repository';
import { IMenuItem } from '../menu-item/menu-item.component';
import { Router } from '@angular/router';
import { TenantsService } from 'app/state/tenants.service';
import { TenantHomeUpdateModel } from 'app/state/tenants.repository';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import { BlobStorageService } from 'app/shared/azure-blob/blob-storage.service';
import { STYLES } from 'app/helpers/constants/styles.constants';
import { TenantMenuItemData } from 'app/api/models/auth/sideBarInfoDto';
import { NotificationsRepository } from 'app/state/notifications.repository';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
  featuresData: Array<TenantMenuItemData> = [];
  TenantFeatures = TenantFeatures;
  subMenuItems: string[] | undefined;
  subMenuName: string | undefined;
  notificationsCount: any;
  menuItems: IMenuItem[] = [];

  homeTenantModel!: TenantHomeUpdateModel;
  videpUrlSafe: SafeResourceUrl | undefined;
  imageSafe: SafeResourceUrl | undefined;
  description: string = '';
  tenantPrimaryColor = '';
  constructor(
    public authRepo: AuthRepository,
    public doctyperepo: DocumentTypesRepository,
    public doctypeservice: DocumentTypesService,
    private router: Router,
    private tenantService: TenantsService,
    public sanitizer: DomSanitizer,
    public generalDataRepository: GeneralDataRepository,
    public blobService: BlobStorageService,
    private notificationsService: NotificationsRepository
  ) {
    this.generalDataRepository.allGeneralData$.subscribe((x) => {
      this.tenantPrimaryColor =
        x.customTenantProperties?.primaryColor ?? STYLES.primaryColor;
    });
  }

  ngOnInit(): void {
    combineLatest([
      this.generalDataRepository.allMobileMenuItems$,
      this.generalDataRepository.allGeneralData$,
      this.notificationsService.notificationCount$,
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([menuItems, generalData, notifications]) => {
        this.menuItems = menuItems;
        this.featuresData = generalData.tenantMenuItemsData;

        this.menuItems.forEach((item) => {
          this.getItemName(item);
          const match = notifications.find(
            (n: any) => n.groupName == item.name
          );
          item.notificationsCount = match ? match.count : 0;
        });

        this.setTenantModelAndUrls();
        this.notificationsCount = notifications;
      });
    this.description =
      window.innerWidth <= 768
        ? this.homeTenantModel.descriptionMobile ?? ''
        : this.homeTenantModel.pageHtml2 ?? '';
  }

  tenantHasNoInfo() {
    if (
      !this.homeTenantModel ||
      (this.homeTenantModel.headline == '' &&
        this.homeTenantModel.logo == undefined &&
        this.homeTenantModel.pageHtml == '' &&
        this.homeTenantModel.videoUrl == '' &&
        this.homeTenantModel.videoUrl == '')
    ) {
      return true;
    }
    return false;
  }

  setTenantModelAndUrls() {
    this.homeTenantModel = {
      headline: '',
      logo: undefined,
      pageHtml: '',
      pageHtml2: '',
      descriptionMobile: '',
      videoUrl: '',
    };
    var tenantId = localStorage.getItem('activeTenantId');
    if (tenantId) {
      this.tenantService.loadTenantHomePageModel(tenantId).subscribe({
        next: (responce) => {
          this.homeTenantModel = responce;
          this.updateContent();
          this.videpUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
            responce.videoUrl!
          );
          if (this.homeTenantModel.logo) {
            this.imageSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
              responce.logo?.fileUrl ?? ''
            );
          }
        },
      });
    }
  }
  updateContent() {
    this.description =
      window.innerWidth <= 768
        ? this.homeTenantModel.descriptionMobile ?? ''
        : this.homeTenantModel.pageHtml2 ?? '';
  }
  reloadToMainMenu() {
    this.router.navigate([], {
      queryParams: {},
    });
  }

  openSubMenu(items: IMenuItem[], name: string) {
    this.menuItems = items;
    this.router.navigate([], {
      queryParams: { subMenuOpened: name },
      queryParamsHandling: 'merge',
    });
  }

  getItemName(itemName: IMenuItem) {
    //inputItem.displayedName = inputItem.title;
    if (itemName) {
      const featureData = this.featuresData.find(
        (data) =>
          data.name.toLocaleLowerCase() === itemName.name.toLocaleLowerCase()
      );

      if (featureData) {
        itemName.name =
          featureData.customTitle || featureData.name.toLocaleLowerCase();
      }
    }
  }
}
